import {type KeyboardEvent} from 'react'

import {ServiceBlock, ServiceGridItem} from './ReportsServicesPage.styled'

import {Typography} from '~/components/general/typography/Typography'
import type {ServiceStatus} from '~/utils/servicesReportPlacement'

type ServiceCardProps = {
  name: string
  staff: string[]
  startDate: string
  endDate: string
  startIdx: number
  endIdx: number
  stackLevel: number
  status: ServiceStatus
  onClick: () => void
}

export const ServiceCard = ({
  name,
  staff,
  startDate,
  endDate,
  startIdx,
  endIdx,
  stackLevel,
  status,
  onClick,
}: ServiceCardProps) => (
  <ServiceGridItem
    role="button"
    tabIndex={0}
    $colStart={startIdx}
    $colEnd={endIdx + 1}
    $stackLevel={stackLevel}
    onClick={onClick}
    onKeyDown={(e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        onClick()
      }
    }}>
    <ServiceBlock direction="column" spacing={0.5} $status={status}>
      <Typography size="sm" weight="medium">
        {startDate} - {endDate}
      </Typography>
      <Typography weight="medium">{name}</Typography>
      <Typography size="sm">{staff.join(', ') || '-'}</Typography>
    </ServiceBlock>
  </ServiceGridItem>
)
